(() => {
  const swiperSelectors = [
    '.home-banner__slideshow .swiper-container',
    '.sf__featured-collection[data-enable-slider="true"] .swiper-container',
    '.product-recommendations[data-enable-slider="true"] .swiper-container',
    '.recently-viewed[data-enable-slider="true"] .swiper-container'
  ].join(',');

  const enableGestures = () => {
    document.querySelectorAll(swiperSelectors).forEach((container) => {
      const slider = container.swiper;
      if (!slider || slider.destroyed) return;

      slider.allowTouchMove = true;
      slider.params.allowTouchMove = true;
      slider.params.simulateTouch = true;
      slider.params.grabCursor = true;
      slider.params.touchRatio = 1;
      slider.params.threshold = 5;

      if (slider.params.autoplay) {
        slider.params.autoplay.disableOnInteraction = false;
      }

      container.classList.add('evelance-gestures-ready');
      slider.update();
    });
  };

  document.addEventListener('DOMContentLoaded', enableGestures);
  window.addEventListener('load', enableGestures);
  document.addEventListener('shopify:section:load', enableGestures);

  new MutationObserver(enableGestures).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  [250, 750, 1500, 3000].forEach((delay) => window.setTimeout(enableGestures, delay));
})();
